import { createContext, Dispatch, SetStateAction } from 'react';
import IContractorListContext from 'rules/interface/context/contractor-list-context.interface';


interface IContext {
    values: IContractorListContext
    setValues: Dispatch<SetStateAction<IContractorListContext>>
}

const ContractorListContext = createContext<IContext>({
    values: {
        selected: [],
        selectedBefore: false
    },
    setValues: () => undefined
});

export default ContractorListContext